<!-- 系统首页-Login -->
<div class="main">
  <div class='body'>
    <div class="content">
      <div class="title">
        <p class="en">Welcome to Smart Engineering System - FAC</p>
        <p class="ch">欢迎来到智慧工程系统 - 厂务</p>
      </div>
      <div class="login">
        <button nz-button nzType="primary" nzSize="large" nzShape="round" (click)="login()">
          <em nz-icon nzType="login"></em>Login
        </button>
      </div>
      <div class="img">
        <img src="../../../assets/images/login-img.png" alt="智慧厂务工程图片">
      </div>
    </div>
  </div>
  <div class="footer">
    <span class="img">
      <img src="../../../assets/images/login-wistron.png" alt="wistron logo">
    </span>
  </div>
</div>